import { useState } from 'react'
import { UpdateEnterpriseInformationForm } from './update-enterprise-information-form'
import CustomEditButton from '../custom-edit-button'
import { useUser } from '@/pages/enterprise/user-provider'
import InfoField from '../info-field'
import { format } from '@react-input/mask'

export default function PaymentEnterpriseInformation() {
  const [editState, setEditState] = useState(false)
  const { paymentEnterpriseInformation, onUpdateSeats } = useUser()

  const phoneNumberMask = {
    mask: '+1 (___) ___-____',
    replacement: { _: /\d/ },
  }

  const billingAddress = paymentEnterpriseInformation.billingAddress
  const mailingAddress = paymentEnterpriseInformation.mailingAddress
  let phoneNumber = paymentEnterpriseInformation.phoneNumber
  if(phoneNumber)
    phoneNumber = format(phoneNumber.replace('+1', ''), phoneNumberMask)

  return (
    <div className="mx-auto w-full gap-4 flex flex-col">
      <div className="flex flex-row gap-4 justify-between">
        <h2 className="text-2xl font-bold ">Profile</h2>
        {!editState && (
          <CustomEditButton
            className="md:flex hidden"
            onClick={() => setEditState(true)}
          />
        )}
      </div>
      {editState ? (
        <UpdateEnterpriseInformationForm
          onSuccess={() => {
            setEditState(false)
            onUpdateSeats()
          }}
          onCancel={() => {
            setEditState(false)
          }}
        />
      ) : (
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 text-sm">
            <InfoField
              label="Enterprise Name"
              value={paymentEnterpriseInformation.enterpriseName}
            />
            <InfoField
              label="Seats"
              value={paymentEnterpriseInformation.seats}
            />
            <InfoField
              label="Billing Address"
              value={
                billingAddress
                  ? billingAddress.address +
                    ', ' +
                    billingAddress.city +
                    ', ' +
                    billingAddress.state +
                    ' ' +
                    billingAddress.zip_code
                  : ''
              }
            />
            <InfoField
              label="Mailing Address"
              value={
                mailingAddress
                  ? mailingAddress.address +
                    ', ' +
                    mailingAddress.city +
                    ', ' +
                    mailingAddress.state +
                    ' ' +
                    mailingAddress?.zip_code
                  : ''
              }
            />
            <InfoField
              label="Phone Number"
              value={phoneNumber}
            />
            <InfoField
              label="Email"
              value={paymentEnterpriseInformation.email}
            />
          </div>
        </div>
      )}
    </div>
  )
}
